import { Link } from "react-router-dom";
import { categories } from "@/mocks/varietyShows";

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            综艺分类导航
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            八大综艺品类，总有一款适合你。点击探索更多精彩内容。
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 bg-background-100 hover:bg-primary-50 rounded-xl transition-all duration-300 cursor-pointer border border-background-200/50 hover:border-primary-200"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-3">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400 mt-1 text-center leading-relaxed">
                {cat.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}